<template>
    <!--/ Section Portfolio Star /-->
  <section id="work" class="portfolio-mf sect-pt4 route">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="title-box text-center">
            <h3 class="title-a" style="margin-top: 5vh">
              Portfólio
            </h3>
            <p class="subtitle-a">
              Serviços feitos para veiculação em celulares.
            </p>
            <div class="line-mf"></div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="work-box">
            <a href="https://www.youtube.com/watch?v=iRyUiuOxSH4" data-lightbox="gallery-mf" data-title="<a href='https://www.youtube.com/watch?v=iRyUiuOxSH4'><i class='fab fa-youtube'></i> Assista no Youtube</a>">
              <div class="work-img">
                <img src="images/work-1.webp" alt="" class="img-fluid">
              </div>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-8">
                    <h2 class="w-title">Baile do DJ William Silva</h2>
                    <div class="w-more">
                      <span class="w-ctegory">Video-chamada de festa</span> / <span class="w-date">Jul 2019 <i class="fab fa-youtube"></i></span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="w-like">
                      <!-- <span class="ion-ios-plus-outline"></span> -->
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="col-md-4">
          <div class="work-box">
            <a href="https://www.youtube.com/watch?v=fXq-Y58_t5A" data-lightbox="gallery-mf" data-title="<a href='https://www.youtube.com/watch?v=fXq-Y58_t5A'><i class='fab fa-youtube'></i> Assista no Youtube</a>">
              <div class="work-img">
                <img src="images/work-2.webp" alt="" class="img-fluid">
              </div>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-8">
                    <h2 class="w-title">Aniversário do Ítalo Ramalho</h2>
                    <div class="w-more">
                      <span class="w-ctegory">Vídeo-chamada de aniversário</span> / <span class="w-date">Jul 2019 <i class="fab fa-youtube"></i></span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="w-like">
                      <!-- <span class="ion-ios-plus-outline"></span> -->
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="col-md-4">
          <div class="work-box">
            <a href="https://www.youtube.com/watch?v=aJII9XGcJsI" data-lightbox="gallery-mf" data-title="<a href='https://www.youtube.com/watch?v=aJII9XGcJsI'><i class='fab fa-youtube'></i> Assista no Youtube</a>">
              <div class="work-img">
                <img src="images/work-3.webp" alt="" class="img-fluid">
              </div>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-8">
                    <h2 class="w-title">Chamada MC Rodolfinho</h2>
                    <div class="w-more">
                      <span class="w-ctegory">Video-chamada</span> / <span class="w-date">Jul 2019 <i class="fab fa-youtube"></i></span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="w-like">
                      <!-- <span class="ion-ios-plus-outline"></span> -->
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="col-md-4">
          <div class="work-box">
            <a href="images/work-4.webp" data-lightbox="gallery-mf">
              <div class="work-img">
                <img src="images/work-4.webp" alt="" class="img-fluid">
              </div>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-8">
                    <h2 class="w-title">Quinta Universitária 04/07</h2>
                    <div class="w-more">
                      <span class="w-ctegory">Imagem divulgação</span> / <span class="w-date">Jul 2018</span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="w-like">
                      <!-- <span class="ion-ios-plus-outline"></span> -->
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="col-md-4">
          <div class="work-box">
            <a href="images/work-5.webp" data-lightbox="gallery-mf">
              <div class="work-img">
                <img src="images/work-5.webp" alt="" class="img-fluid">
              </div>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-8">
                    <h2 class="w-title">Quinta Universitária 14/06</h2>
                    <div class="w-more">
                      <span class="w-ctegory">Imagem divulgação</span> / <span class="w-date">Jun 2019</span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="w-like">
                      <!-- <span class="ion-ios-plus-outline"></span> -->
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="col-md-4">
          <div class="work-box">
            <a href="images/work-6.webp" data-lightbox="gallery-mf">
              <div class="work-img">
                <img src="images/work-6.webp" alt="" class="img-fluid">
              </div>
              <div class="work-content">
                <div class="row">
                  <div class="col-sm-8">
                    <h2 class="w-title">Menu Parada Obrigatória</h2>
                    <div class="w-more">
                      <span class="w-ctegory">Cardápio Completo 10 págs</span> / <span class="w-date">Mar 2019</span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="w-like">
                      <!-- <span class="ion-ios-plus-outline"></span> -->
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        
      </div>
    </div>
  </section>
  <!--/ Section Portfolio End /-->
</template>
<script>
export default {
    
}
</script>
